
(function () {
  var path = (window.location.pathname || '').replace(/\/+$/, '') || '/';
  var aliases = {
    'pages/client': '/products/client',
    'client': '/products/client',
    'products/1-month-sap-s4hana-server-access': '/products/sap-s4hana-2023-server-access-1-month',
    'products/2-month-sap-s4hana-server-access': '/products/sap-s4hana-2023-training-access-2-month',
    'products/3-month-sap-s4hana-server-access': '/products/sap-s4hana-2023-learning-system-3-month',
    'products/dedicated-client': '/products/client',
    'products/dedicated-sap-client': '/products/client',
    'pages/dedicated-client': '/products/client'
  };
  var prefix = '';
  var rest = path.replace(/^\//, '');
  var prefixMatch = rest.match(/^(en(?:-[a-z]{2})?|ar|hi|zh(?:-[a-z]{2})?|fr|de|es|pt|tr|pl|id)(\/.*)?$/i);
  if (prefixMatch && prefixMatch[2]) {
    prefix = '/' + prefixMatch[1];
    rest = prefixMatch[2].replace(/^\//, '');
  }
  var target = aliases[rest.toLowerCase()];
  if (target) {
    window.location.replace(prefix + target + window.location.search + window.location.hash);
    return;
  }

  var header = document.querySelector('[data-site-header]');
  if (!header || header.dataset.navBound === '1') return;
  header.dataset.navBound = '1';

  var toggle = header.querySelector('[data-nav-toggle]');
  var mobile = header.querySelector('[data-nav-mobile]');
  var openIcon = header.querySelector('[data-nav-toggle-icon="open"]');
  var closeIcon = header.querySelector('[data-nav-toggle-icon="close"]');

  function setMobile(open) {
    if (!mobile) return;
    mobile.classList.toggle('is-open', open);
    header.classList.toggle('is-menu-open', open);
    document.documentElement.classList.toggle('erp-mobile-nav-open', open);
    if (open) {
      header.style.setProperty('--erp-menu-top', header.querySelector('.site-header__inner').getBoundingClientRect().bottom + 'px');
    } else {
      mobile.querySelectorAll('details[open]').forEach(function (details) { details.open = false; });
      mobile.querySelector('.site-nav--mobile__body').scrollTop = 0;
    }
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (openIcon) openIcon.hidden = open;
    if (closeIcon) closeIcon.hidden = !open;
  }

  function syncMobile() {
    setMobile(Boolean(mobile && mobile.classList.contains('is-open')));
  }

  function closeDesktop() {
    header.querySelectorAll('.site-nav details[open]').forEach(function (el) {
      el.open = false;
    });
  }

  function bindModulesToggle(details) {
    var summary = details.querySelector('summary');
    if (!summary || summary.dataset.bound === '1') return;
    summary.dataset.bound = '1';
    summary.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      details.open = !details.open;
    });
  }

  if (mobile) {
    mobile.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        if (link.closest('summary')) return;
        setMobile(false);
      });
    });
    if (typeof MutationObserver === 'function') {
      new MutationObserver(syncMobile).observe(mobile, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (toggle && mobile) {
    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setMobile(!mobile.classList.contains('is-open'));
    });
  }

  function layoutNav() {
    header.classList.remove('is-compact');
    if (toggle && getComputedStyle(toggle).display === 'none') setMobile(false);
    else if (mobile && mobile.classList.contains('is-open')) setMobile(true);

    var nav = header.querySelector('.site-nav');
    if (!nav) return;
  }

  layoutNav();
  window.addEventListener('resize', layoutNav);

  header.querySelectorAll('.site-nav a').forEach(function (link) {
    link.addEventListener('click', closeDesktop);
  });

  header.querySelectorAll('.site-nav details, .site-nav--mobile__modules').forEach(bindModulesToggle);

  header.querySelectorAll('.site-nav details').forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (!details.open) return;
      header.querySelectorAll('.site-nav details').forEach(function (other) {
        if (other !== details) other.open = false;
      });
    });
  });

  function mobileNeedsClose() {
    if (!mobile) return false;
    if (mobile.classList.contains('is-open') || header.classList.contains('is-menu-open') ||
        document.documentElement.classList.contains('erp-mobile-nav-open') ||
        mobile.querySelector('details[open]') ||
        (toggle && toggle.getAttribute('aria-expanded') !== 'false') ||
        (openIcon && openIcon.hidden) || (closeIcon && !closeIcon.hidden)) return true;
    return false;
  }

  document.addEventListener('click', function (event) {
    if (!header.contains(event.target)) {
      closeDesktop();
      if (mobileNeedsClose()) setMobile(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      var wasOpen = mobile && mobile.classList.contains('is-open');
      closeDesktop();
      setMobile(false);
      if (wasOpen && toggle) toggle.focus();
    }
  });
  document.addEventListener('focusin', function (event) {
    if (mobile && mobile.classList.contains('is-open') && !header.contains(event.target)) setMobile(false);
  });
})();
